import { render, staticRenderFns } from "./co-borrower.vue?vue&type=template&id=41d37ce1&"
import script from "./co-borrower.vue?vue&type=script&lang=ts&"
export * from "./co-borrower.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports